export const generateCreditScoreColor = (score: number) => {
  if (score <= 629) return "#FF5C5C";
  else if (score >= 630 && score <= 689) return "#F8BB32";
  else if (score >= 690 && score <= 719) return "#40AD87";

  return "#008255";
};
